<template>
  <div class="accidentRecordBox">
    <div class="content">
      <div style="display: flex;width: 100%;justify-content: space-between;">
        <el-button size="small"
          type="primary"
          @click="handleAdd()">新建</el-button>
        <el-radio-group v-model="sourceTypeId"
          size="small"
          @change="changeData">
          <el-radio-button label="2">待审批</el-radio-button>
          <el-radio-button label="3">已审批</el-radio-button>
          <el-radio-button label="4">全部</el-radio-button>
        </el-radio-group>
        <Input search
          enter-button
          placeholder=" 请输入名称"
          v-model="fileNameOrTag"
          @on-search="getData(1)"
          style="width: 300px" />
      </div>
      <div style="margin-top: 20px;">
        <el-table :data="tableData"
          style="width: 100%">
          <el-table-column prop="name"
            label="事故名称">
            <template slot-scope="scope">
              <el-link type="primary"
                size="mini"
                @click="showData(scope.row)"><span>{{ scope.row.name }}</span>
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop=""
            label="事故部门">
            <template slot-scope="{ row }">
              <span v-if="row.departmentVo">{{ row.departmentVo.name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="place"
            label="发生地点"></el-table-column>
          <el-table-column prop="occurTime"
            label="发生时间"></el-table-column>
          <el-table-column prop="reportVo"
            label="事故等级">
            <template slot-scope="scope">
              <span v-if="scope.row.reportVo.level == 0">A级</span>
              <span v-if="scope.row.reportVo.level == 1">B级</span>
              <span v-if="scope.row.reportVo.level == 2">C级</span>
              <span v-if="scope.row.reportVo.level == 3">D级</span>
              <span v-if="scope.row.reportVo.level == 4">E级</span>
              <span v-if="scope.row.reportVo.level == 5">其它</span>
            </template>
          </el-table-column>
          <el-table-column prop=""
            label="事故类别">
            <template slot-scope="scope">
              <span v-if="scope.row.reportVo.accidentType== 0">人员伤亡事故</span>
              <span v-if="scope.row.reportVo.accidentType== 1">火灾爆炸事故</span>
              <span v-if="scope.row.reportVo.accidentType== 2">危化品泄露事故</span>
              <span v-if="scope.row.reportVo.accidentType== 3">设备事故</span>
              <span v-if="scope.row.reportVo.accidentType== 4">工艺事故</span>
            </template>

          </el-table-column>
          <el-table-column prop="programName"
            label="整改负责人"></el-table-column>
          <el-table-column prop="approveName"
            label="指定审批人"></el-table-column>
          <el-table-column prop=""
            label="状态">
            <template slot-scope="scope">
              <el-tag type="info"
                v-if="scope.row.status == 2"
                size="mini">待审批</el-tag>
              <el-tag type="success"
                v-if="scope.row.status == 3"
                size="mini">已审批</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="oper"
            label="操作"
            width="180">
            <template slot-scope="scope">
              <div slot="reference"
                class="name-wrapper">
                <el-link type="primary"
                  @click="handRead(scope.row)">审批</el-link>
                |
                <el-link type="primary"
                  v-if="scope.row.status !== 3"
                  @click="handChange(scope.row.id,scope.row)">编辑</el-link>
                <span v-if="scope.row.status !== 3"> | </span>
                <el-link type="danger"
                  @click="handleDel(scope.row)">删除</el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 10px">
          <Page :total="total"
            :page-size="sizePage"
            :current="pageChange"
            @on-change="getData" />
        </div>
      </div>
    </div>
    <el-dialog title="审批"
      :visible.sync="dialogVisible"
      width="30%"
      @close="closeSpDia">
      <el-form ref="form"
        :model="form"
        label-width="80px">
        <el-form-item label="审批意见">
          <el-input :disabled="isChange"
            type="textarea"
            :rows="3"
            v-model="content"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
        class="dialog-footer">
        <el-button @click="dialogVisible = false"
          size="small">取 消</el-button>
        <el-button type="primary"
          @click="sureClick"
          :disabled="isChange"
          size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
			:show-close="false"
      size="60%">
			<div slot="title" class="drawerTitle">
        <p>事故名称：{{ infoForm.name }}
          <i class="el-icon-circle-close" @click="handleClose"></i>
        </p>
        <div class="tWord">
          <div><p>事故等级</p><span>
						<span v-if="infoForm.level == 0">A级</span>
						<span v-if="infoForm.level == 1">B级</span>
						<span v-if="infoForm.level == 2">C级</span>
						<span v-if="infoForm.level == 3">D级</span>
						<span v-if="infoForm.level == 4">E级</span>
						<span v-if="infoForm.level == 5">其它</span>
					</span></div>
          <div><p>事故类别</p><span>
						<span v-if="infoForm.accidentType== 0">人员伤亡事故</span>
						<span v-if="infoForm.accidentType== 1">火灾爆炸事故</span>
						<span v-if="infoForm.accidentType== 2">危化品泄露事故</span>
						<span v-if="infoForm.accidentType== 3">设备事故</span>
						<span v-if="infoForm.accidentType== 4">工艺事故</span>
					</span></div>
        </div>
      </div>
			<div class="drawerBody">
        <el-tabs v-model="activeName">
          <el-tab-pane label="事故详情" name="a"></el-tab-pane>
        </el-tabs>
        <div class="bodyInner">
          <el-form v-if="drawer"
						:inline="true"
						:model="infoForm"
						class="demo-form-inline"
						style="background-color: white;overflow:auto;height: 500px">
						<el-form-item label="事故名称："
							style="width: 40%;margin-left: 8%">
							<span size="small">{{infoForm.name}}</span>
						</el-form-item>
						<el-form-item label="事故部门："
							style="width: 40%;margin-left: 5%">
							<span size="small"
								v-if="infoForm.departmentVo">{{infoForm.departmentVo.name}}</span>
						</el-form-item>
						<el-form-item label="发生地点："
							style="width: 40%;margin-left: 8%">
							<span size="small">{{infoForm.place}}</span>
						</el-form-item>
						<el-form-item label="发生时间："
							style="width: 40%;margin-left: 5%">
							<span size="small">{{infoForm.occurTime}}</span>
						</el-form-item>
						<el-form-item label="事故描述："
							style="width: 40%;margin-left: 8%">
							<span size="small">{{infoForm.contentHtml}}</span>
						</el-form-item>
						<el-form-item label="审批人："
							style="width: 40%;margin-left: 5%">
							<span size="small">{{infoForm.approveName}}</span>
						</el-form-item>
						<el-form-item label="事故等级："
							style="width: 40%;margin-left: 8%">
							<span v-if="infoForm.reportVo.level == 0">A级</span>
							<span v-if="infoForm.reportVo.level == 1">B级</span>
							<span v-if="infoForm.reportVo.level == 2">C级</span>
							<span v-if="infoForm.reportVo.level == 3">D级</span>
							<span v-if="infoForm.reportVo.level == 4">E级</span>
							<span v-if="infoForm.reportVo.level == 5">其它</span>
						</el-form-item>
						<el-form-item label="事故类别："
							style="width: 40%;margin-left: 5%">
							<span v-if="infoForm.reportVo.accidentType== 0">人员伤亡事故</span>
							<span v-if="infoForm.reportVo.accidentType== 1">火灾爆炸事故</span>
							<span v-if="infoForm.reportVo.accidentType== 2">危化品泄露事故</span>
							<span v-if="infoForm.reportVo.accidentType== 3">设备事故</span>
							<span v-if="infoForm.reportVo.accidentType== 4">工艺事故</span>
						</el-form-item>
						<el-form-item label="人员伤亡情况："
							style="width: 40%;margin-left: 8%">
							<span size="small">{{infoForm.reportVo.casualties}}</span>
						</el-form-item>
						<el-form-item label="火灾损失影响："
							style="width: 40%;margin-left: 5%">
							<span size="small">{{infoForm.reportVo.fireLoss}}</span>
						</el-form-item>
						<el-form-item label="设备事故影响："
							style="width: 40%;margin-left: 8%">
							<span size="small">{{infoForm.reportVo.deviceAffect}}</span>
						</el-form-item>
						<el-form-item label="工艺事故影响："
							style="width: 40%;margin-left: 5%">
							<span size="small">{{infoForm.reportVo.craftAffect}}</span>
						</el-form-item>
						<el-form-item label="附件："
							style="width: 40%;margin-left: 8%">
							<el-link v-for="(item1,index) in trainStuff"
								type="primary"
								:key="index"
								@click="download(item1)">{{item1.name}}&nbsp;&nbsp;&nbsp;</el-link>
						</el-form-item>
						<el-form-item label="事故树分析表："
							style="width: 40%;margin-left: 5%">
							<el-link v-for="(item1,index) in analysisFile"
								type="primary"
								:key="index"
								@click="download(item1)">{{item1.name}}&nbsp;&nbsp;&nbsp;</el-link>
						</el-form-item>
						<el-form-item label="最终调查报告："
							style="width: 40%;margin-left: 8%">
							<el-link v-for="(item1,index) in reportFile"
								type="primary"
								:key="index"
								@click="download(item1)">{{item1.name}}&nbsp;&nbsp;&nbsp;</el-link>
						</el-form-item>
					</el-form>
        </div>
      </div>
    </el-drawer>
  </div>
</template>


<script>
import { downLoadDocument } from '@/api/downLoad'
export default {
  data() {
    return {
      activeName: 'a',
      pageChange: 1,
      infoForm: { departmentVo: { name: '' }, reportVo: {} },
      drawer: false,
      trainStuff: [
        {
          name: '',
          response: { data: '' }
        }
      ],
      analysisFile: [
        {
          name: '',
          response: { data: '' }
        }
      ],
      reportFile: [
        {
          name: '',
          response: { data: '' }
        }
      ],
      form: {},
      dealId: '',
      content: '',
      dialogVisible: false,
      total: 0,
      sizePage: 10,
      currentPage: 1,
      tableData: [{ reportVo: {} }],
      fileNameOrTag: '',
      sourceTypeId: 4,
      isChange: false
    }
  },
  mounted: function() {
    this.getData(1)
  },
  created() {},
  methods: {
    showData(row) {
      this.trainStuff = []
      this.analysisFile = []
      this.reportFile = []
      this.infoForm = row
      // // return
      let files = JSON.parse(this.infoForm.reportVo.trainStuff)
      // // let files = JSON.parse(this.infoForm.trainStuff);
      if (files) {
        for (var i = 0; i < files.length; i++) {
          let myFile = {}
          var file = files[i]
          myFile.response = {}
          myFile.response.data = file.url
          myFile.name = file.fileName
          this.trainStuff.push(myFile)
        }
      }
      let files1 = JSON.parse(this.infoForm.reportVo.analysisFile)
      // let files1 = JSON.parse(this.infoForm.analysisFile);
      if (files1) {
        for (var i = 0; i < files1.length; i++) {
          let myFile = {}
          var file = files1[i]
          myFile.response = {}
          myFile.response.data = file.url
          myFile.name = file.fileName
          this.analysisFile.push(myFile)
        }
      }
      let files2 = JSON.parse(this.infoForm.reportVo.reportFile)
      // let files2 = JSON.parse(this.infoForm.reportFile);
      if (files2) {
        for (var i = 0; i < files2.length; i++) {
          let myFile = {}
          var file = files2[i]
          myFile.response = {}
          myFile.response.data = file.url
          myFile.name = file.fileName
          this.reportFile.push(myFile)
        }
      }
      this.drawer = true
    },
    handleClose() {
      this.drawer = false
    },
    handRead(row) {
      this.dealId = row
      this.dialogVisible = true
      this.content = row.reportVo.approveText
      if (row.status == 3) {
        this.isChange = true
      }
    },
    // 关闭审批的弹窗
    closeSpDia() {
      this.isChange = false
    },
    sureClick() {
      let formData = new FormData()
      formData.append('id', this.dealId.reportVo.id)
      formData.append('approveText', this.content)

      this.componentsMoudel.httpRequest
        .getRequestHander('/accidentReport/check')
        .openLoad()
        .startPost(formData)
        .then(res => {
          this.$message({
            showClose: true,
            message: '审批成功',
            type: 'success'
          })
          this.dialogVisible = false
          this.getData(1)
        })
    },
    changeData(val) {
      this.getData(1)
    },
    getData(page) {
      this.pageChange = page
      let url = ''
      if (this.sourceTypeId == 4) {
        url =
          this.componentsMoudel.getData('urls').getAccidentReport +
          '?limit=' +
          this.sizePage +
          '&curPage=' +
          page +
          '&searchParam=' +
          this.fileNameOrTag
      } else {
        url =
          this.componentsMoudel.getData('urls').getAccidentReport +
          '?limit=' +
          this.sizePage +
          '&curPage=' +
          page +
          '&searchParam=' +
          this.fileNameOrTag +
          '&status=' +
          this.sourceTypeId
      }
      this.componentsMoudel.httpRequest
        .getRequestHander(url)
        .openLoad()
        .startGet()
        .then(res => {
          this.tableData = res.body.data
          for (var i = 0; i < this.tableData.length; i++) {
            this.tableData[i].level = this.tableData[i].reportVo.level
            this.tableData[i].accidentType = this.tableData[
              i
            ].reportVo.accidentType
          }
          // console.log(this.tableData[0]);
          this.currentPage = res.body.page
          this.total = res.body.cum
          this.pageTotal = res.body.pageTotal
        })
    },

    handleSizeChange(val) {
      this.sizePage = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    handleAdd() {
      this.$router.push({
        path: 'addAccidentRec'
      })
    },
    handChange(id, row) {
      this.$router.push({
        name: 'addAccidentRec',
        params: { key: row }
      })
    },
    handleDel(row) {
      this.componentsMoudel.httpRequest
        .getRequestHander('/accidentReport/delete/' + row.reportVo.id)
        .openLoad()
        .startPost(this.ruleForm)
        .then(res => {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          })
          this.getData(this.pageChange)
        })
    },
    // 下载文件
    download(val) {
      downLoadDocument(val.response.data, val.name)
    }
  }
}
</script>

<style scoped>
.el-form--inline .el-form-item {
  margin-top: -8px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.addBtn {
  width: 100px;
  position: absolute;
  top: 10px;
  right: 10px;
}
.accidentRecordBox /deep/ .el-dialog__body {
  padding-bottom: 0;
}

/* <!--         抽屉样式           --> */
.drawerTitle {
  box-shadow: 0px 5px 5px -5px black;
  height: 120px;
  padding: 0 15px
}
.drawerTitle > p {
  color: #000000;
  font-size: 18px;
  line-height: 55px;
}
.drawerTitle > p > i {
  font-size: 30px;
  float: right;
  margin: 15px 10px 0 0;
}
.drawerTitle > p > i:hover {
  color: #409EFF
}
.el-drawer__header {
  padding: 0 15px;
  margin-bottom: 0
}

/* 解决tab切换会有蓝色边框的问题 */ 
.accidentRecordBox /deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
box-shadow: none;
border-top-left-radius: 20px;
border-top-right-radius: 20px;
}

/*  */

.tWord {
  display: flex
}
.tWord div > p {
  font-size: 15px;
  line-height: 25px
}
.tWord div > span {
  color: #000000
}
.tWord div {
  width: 220px
}
.drawerBody {
  width: 100%;
  height: calc(100vh - 160px);
  background: rgb(247,247,247);
  overflow: hidden;
  padding: 10px 20px 20px;
}
.bodyInner {
  background: white;
  height: calc(100% - 60px);
  width: 100%;
  border: 1px solid #eaeaea;
  overflow: scroll;
}
</style>
